<template>
  <div>
    <script id="editor" type="text/plain"></script>
  </div>
</template>

<script>
import "../../static/ueditor/ueditor.config.js";
import "../../static/ueditor/ueditor.all.js";
import "../../static/ueditor/lang/zh-cn/zh-cn.js";

export default {
  name: "UEditor",
  props: {
    id: {
      type: String
    },
    config: {
      type: Object
    }
  },
  data() {
    return {
      editor: null
    };
  },
  mounted() {
    //初始化UE
    const _this = this;
    UE.delEditor('editor')
    this.editor = UE.getEditor("editor", this.config);
  },
  destoryed() {
    this.editor.destory();
  },
  methods: {
    getUEContent: function() {
      return this.editor.getContent();
    },
    setContentInfo: function(content) {
      this.editor.ready(function() {
        if (!content || content == null)
        {
content = ''
        }
        this.setContent(content);
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ueditor.vue